<template>
    <card :to="$config.public.isSpoferanDomain ? $app(`${article.type.value}-article`, {params: {article: article._key}, state: {article_ts: $date(article.updated_at).unix()}}) : $spoferanUrl(`${article.type.value}/${article._key}`)" v-bind="cardProps"
		  :class="{'is-clicked': isClicked}"
		  class="article-preview" @click="isClicked = true">
        <card-image v-if="article.image" :src="article.image" :alt="article.title" :ratio="16/9" :size="{width: '100vw', md: {width: 760}}" class="article-preview-image"/>
        <card-title large class="article-preview-title">{{ article.title }}</card-title>
        <card-subtitle small>
            <sport-type-text :sport-types="article.sportTypes" truncate>
				<meta-text :color="article.type.value === 'news' ? $config.public.colors.news : $config.public.colors.blog">{{ article.type.title }}</meta-text>
				<meta-text v-if="article.category">{{ article.category.title }}</meta-text>
			</sport-type-text>
        </card-subtitle>
        <card-text class="pb-8">
			<span class="truncate-4-lines article-preview-description">{{ article.preview_text }}</span>
		</card-text>
        <card-buttons between>
            <span>
                <meta-text x-small>{{ $date(article.published_at).calendar('L') }}</meta-text>
            </span>
            <chip v-if="article.club" small class="ml-8 overflow-hidden">
                <div class="flex items-center">
                    <avatar :model="article.club" tile :size="16" class="mr-8"/>
                    <span class="truncate">{{ article.club.display_name }}</span>
                </div>
            </chip>
			<chip v-else-if="article.author" small class="ml-8 overflow-hidden">
				<div class="flex items-center">
					<avatar :model="article.author" :size="16" class="mr-8"/>
					<span class="truncate">{{ article.author.display_name }}</span>
				</div>
			</chip>
        </card-buttons>
    </card>
</template>

<script>
import CardMixin from "../Card/CardMixin";
	import {truncate} from "@spoferan/spoferan-ts-core"

    export default {
        name: 'ArticleCard',

        mixins: [CardMixin],

        props: {

            // The article object to display
            article: {
                type: Object,
                required: true
            }
        },

		data() {
			return {
				isClicked: false,
			}
		},

		methods: {
			truncate
		}
    }
</script>

<style>
.article-preview.is-clicked .article-preview-image img {
  view-transition-name: article-image;
}
.article-preview.is-clicked .article-preview-title {
  view-transition-name: article-title;
}
.article-preview.is-clicked .article-preview-description {
  view-transition-name: article-description;
}
</style>
